var ExceptionTypeEnum;
(function (ExceptionTypeEnum) {
    ExceptionTypeEnum["platformComponentElement"] = "platformComponentElement";
    ExceptionTypeEnum["platform"] = "platform";
    ExceptionTypeEnum["componentElement"] = "componentElement";
    ExceptionTypeEnum["component"] = "component";
    ExceptionTypeEnum["service"] = "service";
    ExceptionTypeEnum["generic"] = "generic";
    ExceptionTypeEnum["serverErrorResponse"] = "serverErrorResponse";
    ExceptionTypeEnum["connectionProblem"] = "connectionProblem";
    ExceptionTypeEnum["unableToParseServerResponse"] = "unableToParseServerResponse";
    ExceptionTypeEnum["shoppingCart"] = "shoppingCart";
})(ExceptionTypeEnum || (ExceptionTypeEnum = {}));
export default ExceptionTypeEnum;
//# sourceMappingURL=ExceptionTypeEnum.js.map